import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

const baseService = createCrudService("intakeForms", [], router);

export const intakeFormsService = {
  ...baseService,

  getByClient: async (clientId) => {
    return api.getCall(`/api/intakeForms/client/${clientId}`);
  },

  complete: async (id) => {
    return api.postCall(`/api/intakeForms/${id}/complete`);
  },

  // Contacts sub-resource
  addContact: async (intakeId, contact) => {
    return api.postCall(`/api/intakeForms/${intakeId}/contacts`, contact);
  },

  updateContact: async (intakeId, contactId, contact) => {
    return api.putCall(`/api/intakeForms/${intakeId}/contacts/${contactId}`, contact);
  },

  deleteContact: async (intakeId, contactId) => {
    return api.deleteCall(`/api/intakeForms/${intakeId}/contacts/${contactId}`);
  },

  // Medications sub-resource
  addMedication: async (intakeId, medication) => {
    return api.postCall(`/api/intakeForms/${intakeId}/medications`, medication);
  },

  updateMedication: async (intakeId, medicationId, medication) => {
    return api.putCall(`/api/intakeForms/${intakeId}/medications/${medicationId}`, medication);
  },

  deleteMedication: async (intakeId, medicationId) => {
    return api.deleteCall(`/api/intakeForms/${intakeId}/medications/${medicationId}`);
  },

  uploadPdf: async (formData) => {
    return api.postFormDataCall("/api/intakeForms/upload-pdf", formData);
  },
};
